import React from "react";

export default function ComingSoonPage() {
    return (
        <h2 className="margin-top-md">Coming Soon!</h2>
    );
}